<template>
  <div class="copyright">
    <v-layout>
      <v-flex xs12>
        © 2019 GEAT. All Rights Reserved.
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="sass" src="./copyright.sass"></style>
